import styled from "styled-components";

export const ContainerStatus = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 250px;
  gap: 50px;

  @media (min-width: 744px) {
    margin-top: 315px;
  }

  @media (min-width: 1440px) {
    margin-top: 256px;
  }
`;

export const ContainerIconGreen = styled.div`
  width: 171px;
  height: 171px;
  background: #1ac63f;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 744px) {
    width: 301px;
    height: 301px;
  }
`;

// Not confirm email

export const NotComfirmIcon = styled.svg`
  width: 50px;
  height: 50px;
  fill: #fff;

  @media (min-width: 744px) {
    width: 87px;
    height: 87px;
  }
`;

export const ContainerIconRed = styled.div`
  width: 171px;
  height: 171px;
  background: #f64747;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 744px) {
    width: 301px;
    height: 301px;
  }
`;

export const DoneIconConfirmEmail = styled.svg`
  width: 50px;
  height: 50px;
  fill: #fff;

  @media (min-width: 744px) {
    width: 87px;
    height: 87px;
  }
`;

export const StatusEmail = styled.span`
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;

  @media (min-width: 744px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }
`;

export const StatusEmailTime = styled.span`
  font-size: 24px;
  font-weight: 400;
  line-height: 1.2;

  @media (min-width: 744px) {
    font-size: 32px;
    line-height: 1.18;
  }
`;
